import { useTranslation } from 'react-i18next';
import { getPrivacyContent } from './content';

export default function PrivacyPolicy() {
  const { i18n } = useTranslation();
  const { title, body } = getPrivacyContent(i18n.language);

  return (
    <div className="min-h-[calc(100vh-var(--spacing)*45)] bg-[#FAFAFA]">
      <div className="px-6 py-10 mx-auto max-w-4xl md:px-10">
        <h1 className="mb-4 text-[26px] font-bold text-[#1a1a1a] md:text-[32px]">{title}</h1>
        <div className="text-[20px] leading-[1.75] text-[#333] whitespace-pre-wrap">{body}</div>
      </div>
    </div>
  );
}
